// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"180":"video","303":"widget","495":"feed"}[chunkId] + "." + {"180":"c1cb08a4bf52e9120471","303":"6c97a4fbec77a3a2f236","495":"f0e8bfdc2017a5442709"}[chunkId] + ".js";
};